var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsappGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 151,
    viewBox: "0 0 148 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_666_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15846 74.5965C3.15499 87.2834 6.42949 99.6713 12.6559 110.59L2.56299 147.896L40.2752 137.886C50.7059 143.635 62.3928 146.647 74.269 146.648H74.3002C113.506 146.648 145.42 114.35 145.437 74.6532C145.444 55.4171 138.051 37.3287 124.619 23.72C111.189 10.1124 93.328 2.61449 74.2973 2.60571C35.0871 2.60571 3.17522 34.901 3.15903 74.5965",
    fill: "url(#paint0_linear_666_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.618594 74.573C0.614547 87.7164 4.00641 100.547 10.4548 111.857L0 150.501L39.0645 140.132C49.828 146.073 61.9467 149.205 74.2781 149.21H74.3099C114.922 149.21 147.983 115.751 148 74.6326C148.007 54.7053 140.348 35.9667 126.436 21.8704C112.522 7.77592 94.0222 0.0081938 74.3099 0C33.6908 0 0.635359 33.4541 0.619172 74.573H0.618594ZM23.8823 109.909L22.4237 107.565C16.2921 97.6953 13.0558 86.2895 13.0604 74.5776C13.0737 40.4007 40.5485 12.595 74.333 12.595C90.6939 12.6021 106.07 19.0588 117.635 30.7736C129.199 42.4895 135.562 58.0636 135.558 74.628C135.543 108.805 108.068 136.614 74.3099 136.614H74.2856C63.2937 136.608 52.5134 133.62 43.1119 127.973L40.8746 126.629L17.6929 132.782L23.8823 109.909V109.909Z",
    fill: "url(#paint1_linear_666_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8921 43.3967C54.5126 40.293 53.061 40.2304 51.7492 40.1759C50.6751 40.1291 49.4471 40.1326 48.2203 40.1326C46.9924 40.1326 44.9973 40.6003 43.3109 42.4643C41.6228 44.3302 36.866 48.8391 36.866 58.0097C36.866 67.1809 43.4641 76.0437 44.3839 77.2886C45.3049 78.5311 57.1217 97.9527 75.8368 105.424C91.3906 111.633 94.5559 110.399 97.9315 110.087C101.308 109.777 108.826 105.579 110.359 101.227C111.894 96.8747 111.894 93.1441 111.434 92.3646C110.974 91.5879 109.746 91.1214 107.905 90.1897C106.063 89.2574 97.0106 84.7478 95.323 84.1257C93.6349 83.5041 92.4076 83.1939 91.1796 85.0604C89.9517 86.9239 86.4257 91.1214 85.351 92.3646C84.2774 93.6106 83.2027 93.7657 81.3619 92.8334C79.5194 91.8981 73.5896 89.9322 66.5544 83.5826C61.0807 78.6417 57.3853 72.5403 56.3112 70.6738C55.237 68.8103 56.1961 67.8002 57.1194 66.8713C57.9467 66.0361 58.9613 64.6947 59.8828 63.6067C60.8009 62.5181 61.1073 61.7414 61.7213 60.4983C62.3358 59.254 62.0283 58.1654 61.5687 57.2331C61.1073 56.3007 57.5293 47.0827 55.8921 43.3973",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_666_16",
    x1: 73.9998,
    y1: 147.896,
    x2: 73.9998,
    y2: 2.60571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_666_16",
    x1: 74,
    y1: 150.501,
    x2: 74,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 151,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappGreen);
export default __webpack_public_path__ + "static/media/whatsapp-green.4c86d58f52f1cf1288e33f2bc58b8bde.svg";
export { ForwardRef as ReactComponent };